import { Messages, Validators } from "../../types";

// These are now translation keys instead of hardcoded messages
export const messages: Messages = {
    minLength: "warnings.minLength",
    maxLength: "warnings.maxLength",
    required: "warnings.required",
    pattern: "warnings.pattern",
};

export const criterions = {
    password: {
        required: true,
    },
    email: {
        required: true,
        pattern:
            /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
    },
};

export const validators: Validators = {
    password: { ...criterions.password },
    email: { ...criterions.email },
};
